import {Component, DoCheck, KeyValueDiffers, OnInit} from '@angular/core';
import {LoaderService} from '../shared/loader/loader-service.services';
import {Router} from '@angular/router';
import {DataSharingService} from '../services/data-sharing.service';
import {UtilService} from '../services/UtilService';
import {ApiService} from '../services/api.service';

@Component({
  selector: 'app-trs-calc-page',
  templateUrl: './trs-calc-page.component.html',
  styleUrls: ['./trs-calc-page.component.scss']
})
export class TrsCalcPageComponent implements OnInit, DoCheck {

  tabList = [''];
  calcType = 'USD';
  currentView = 'Disclaimer';
  holidays = [];
  tradeDate = '';
  tradeDateToDisplay = '';
  validTradeDate: boolean;
  min = '2020-03-20';
  today = '';
  maturityDate = '';
  priorIMMDate = '';
  priorIMMDateDiff = '';
  sofrai = '';
  previousDate = '';
  previousSofrai = '';
  prevEuribor = '';
  nextIMMDate = '';
  nextIMMDateDiff = '';
  nextSofrai = '';
  nextEuribor = '';
  effectiveDate = '';
  accruedFloatingRate = '';
  accruedAmount = '';
  firstCouponDate = '';
  performanceLeg = '';
  tradeValue = '';
  couponFloatingRate = '';
  firstCouponAmount = '';
  lastCouponDate = '';
  notional = '';
  initialIndexLevel = '';
  finalIndexLevel = '';
  enableCalculate = false;
  enableOutput = false;
  IMMDate: any;
  currency: any;
  IMMDateValues = [''];

  showOutput = false;
  showAlert1 = false;
  alert1 = 'Not a valid business date.';
  differ: any;

  constructor(private shareService: DataSharingService, private loader: LoaderService, private route: Router,
              private apiService: ApiService, private utilService: UtilService, private differs: KeyValueDiffers) {
    this.IMMDate = {
      label: '',
      options: []
    };

    this.currency = {
      label: '',
      options: []
    };
    this.today = new Date().toISOString().split('T')[0];

    // SET TRADE DATE PER IDXPLATFORM-14242
    this.tradeDate = this.getValidBusinessDate(new Date(), 'reverse').toString();
    this.tradeDateToDisplay = this.formatDate(this.getValidBusinessDate(new Date(), 'reverse'));
    this.validTradeDate = true;
    this.differ = this.differs.find({}).create();
  }

  ngOnInit(): void {
    // @ts-ignore
    const tabGroup = JSON.parse(window.sessionStorage.getItem('tabList')) ? JSON.parse(window.sessionStorage.getItem('tabList')) :
      {
        all: [],
        futures: [],
        trs: [],
        esg: [],
      };
    this.tabList = tabGroup.trs.length > 0 ? tabGroup.trs : ['screener', 'trs calculator', 'documentation'];
    this.loader.hide();
    this.getHolidays();
    this.getIMMDates();

    this.currency.options.push({
        label: 'USD',
        value: 'USD',
        selected: true
      },
      {
        label: 'EUR',
        value: 'EUR',
        selected: false
      });
  }

  getHolidays(): void{
    // this.holidays = this.shareService.holidays.find((calendar: any) => calendar.calendarName === this.calcType).calendar;
    this.holidays = [];
  }

  ngDoCheck(): void {
    const change = this.differ.diff(this);
    if (change){
      change.forEachChangedItem((item: any) => {
        if (item.key === 'calcType' || item.key === 'tradeDate' || item.key === 'maturityDate' || item.key === 'notional' ||
          item.key === 'initialIndexLevel' || item.key === 'finalIndexLevel'){
          this.showOutput = false;
        }
        if (this.enableCalculate){
          switch (this.calcType) {
            case 'USD':
              if (this.previousSofrai !== '' && this.sofrai !== ''){
                this.calculateUSDOutput();
              }
              break;
            case 'EUR':
              if (this.prevEuribor !== ''){
                this.calculateEUROutput();
              }
              break;
          }
        }
        if (item.key === 'nextSofrai' && item.currentValue !== ''){
          this.enableCalculate = true;
        }
      });
    }
  }

  getIMMDates(): void {
    this.IMMDateValues = [''];
    this.IMMDate.options = [];
    let dates = new Date(this.tradeDate);
    dates.setFullYear(dates.getFullYear() - 1);
    const months = [2, 5, 8, 11];
    const Maxdate = new Date(this.tradeDate);
    const Mindate = new Date(this.min);
    Maxdate.setFullYear(Maxdate.getFullYear() + 2);
    do {
      for (const month of months) {
        dates.setDate(20);
        dates.setMonth(month);
        dates = this.utilService.getBusinessDay(dates);
        dates = this.getValidBusinessDate(dates, 'forward');
        if (dates.getTime() <= Maxdate.getTime() && dates.getTime() >= Mindate.getTime()) {
          this.IMMDateValues.push(this.formatDate(dates));
        } else {
          break;
        }
      }
      // Maxdate.setMonth(new Date(this.IMMDateValues[1]).getMonth());
      dates.setFullYear(dates.getFullYear() + 1);
    } while (dates.getFullYear() <= Maxdate.getFullYear());

    this.IMMDateValues.splice(0, 1);  // TO REMOVE BLANK ENTRY
    this.IMMDateValues.forEach((dt: string) => {
      if (this.formatDate(Mindate) !== dt &&
        new Date(this.formatDate(new Date(this.tradeDate))).getTime() <= new Date(dt).getTime()) {
        this.IMMDate.options.push({
          label: dt,
          value: dt,
          selected: false
        });
      }
    });
    this.IMMDate.options[0].selected = true;

    this.maturityDate = this.IMMDate.options.find((dt: any) => dt.selected).value;
  }

  updateIMMDates(): void{
    // SET T-1 DATE PER IDXPLATFORM-14242
    const prevDate = this.getValidBusinessDate(this.utilService.addDaysTo(new Date(this.utilService.formatDate(this.tradeDate)), -1), 'reverse');
    this.previousDate = new Date(prevDate).getTime() < new Date(this.min).getTime() ? this.formatDate(new Date(this.min)) :
      this.formatDate(prevDate);

    let tempDate: string | undefined;
    if (this.IMMDateValues.includes(this.formatDate(new Date(this.tradeDate))) &&
      this.maturityDate !== this.formatDate(new Date(this.tradeDate))){
      tempDate = this.tradeDate;
    }else{
      tempDate = this.IMMDateValues.filter((dt: string) => new Date(dt).getTime() <
        new Date(this.formatDate(new Date(this.tradeDate))).getTime()).pop();
    }
    if (tempDate === undefined){
      tempDate = this.IMMDateValues[0];
    }
    // @ts-ignore
    this.priorIMMDate = this.formatDate(this.getValidBusinessDate(new Date(tempDate), 'forward'));

    this.priorIMMDateDiff = this.priorIMMDate;
    for (let i = 2; i > 0; i--) {
      this.priorIMMDateDiff = this.formatDate(this.getValidBusinessDate(this.utilService.addDaysTo(new Date(this.priorIMMDateDiff), -1), 'reverse'));
    }

    // @ts-ignore
    this.nextIMMDate = new Date(this.formatDate(new Date(this.tradeDate))).getTime() === new Date(this.maturityDate).getTime() ?
      this.IMMDateValues.find((date: string) => new Date(date).getTime() >= new Date(this.formatDate(new Date(this.tradeDate))).getTime()) :
      this.IMMDateValues.find((date: string) => new Date(date).getTime() > new Date(this.formatDate(new Date(this.tradeDate))).getTime()) ;
    this.nextIMMDateDiff = this.nextIMMDate;
    for (let i = 2; i > 0; i--){
      this.nextIMMDateDiff = this.formatDate(this.getValidBusinessDate(this.utilService.addDaysTo(new Date(this.nextIMMDateDiff), -1), 'reverse'));
    }
  }

  formatDate(date: Date): string {
    const formattedDate = date.toString().split(' ');
    return formattedDate[1] + ' ' + formattedDate[2] + ' ' + formattedDate[3];
  }

  formatDateAsISO(date: Date): string {
    return isNaN(date.getTime()) ? '' : (date.getFullYear() + '-' +
      (date.getMonth() + 1).toLocaleString('en-US', {minimumIntegerDigits: 2})
      + '-' + date.getDate().toLocaleString('en-US', {minimumIntegerDigits: 2}));
  }

  openPicker(element: string): void {
    // @ts-ignore
    document.querySelector('#' + element).showPicker();
  }

  tradeDateChanged(): void {
    this.tradeDateToDisplay = this.formatDate(new Date(new Date(this.tradeDate).toISOString().slice(0, -1)));
    if (this.isHoliday(new Date(this.utilService.formatDate(this.tradeDate))) ||
      this.isWeekend(new Date(this.utilService.formatDate(this.tradeDate)))) {
      this.validTradeDate = false;
      if (this.isWeekend(new Date(this.utilService.formatDate(this.tradeDate)))){
        this.alert1 = 'Not a Valid Business Date - Weekend';
      }else{
        this.alert1 = 'Not a Valid Business Date - ' + this.getHolidayName(new Date(this.utilService.formatDate(this.tradeDate)));
      }
      setTimeout(() => {
        this.openPicker('tradeDate');
        this.showAlert1 = true;
      }, 100);
    }else{
      this.validTradeDate = true;
      this.showAlert1 = false;
      this.getIMMDates();
    }
  }

  priorIMMDateChanged(): void {
    console.log(this.tradeDate);
  }

  priorIMMDateDiffChanged(): void {
    console.log(this.tradeDate);
  }

  sofraiChanged(): void {
    console.log(this.tradeDate);
  }

  euriborChanged(): void {
    console.log(this.tradeDate);
  }

  previousDateChanged(): void {
    console.log(this.tradeDate);
  }

  previousSofraiChanged(): void {
    console.log(this.tradeDate);
  }

  nextDateChanged(): void {
    console.log(this.tradeDate);
  }

  nextIMMDateDiffChanged(): void {
    console.log(this.tradeDate);
  }

  nextSofraiChanged(): void {
    console.log(this.tradeDate);
  }

  nextEuriborChanged(): void {
    console.log(this.tradeDate);
  }

  IMMDateChanged(event: any): void {
    this.maturityDate = event.value;
  }

  notionalModelChange(): void{
    if (this.notional.length > 0) {
      // @ts-ignore
      document.getElementById('notional').value = parseFloat(this.notional.split('.')[0].replace(/,/g, '')).toLocaleString()
        + (this.notional.split('.')[1] !== undefined ? '.' + this.notional.split('.')[1] : '');
    }
  }

  initialIndexLevelModelChange(): void{
    if (this.initialIndexLevel.length > 0) {
      // @ts-ignore
      document.getElementById('initialIndexLevel').value =
        parseFloat(this.initialIndexLevel.split('.')[0].replace(/,/g, '')).toLocaleString()
        + (this.initialIndexLevel.split('.')[1] !== undefined ? '.' + this.initialIndexLevel.split('.')[1] : '');
    }
  }

  finalIndexLevelModelChange(): void{
    if (this.finalIndexLevel.length > 0) {
      // @ts-ignore
      document.getElementById('finalIndexLevel').value =
        parseFloat(this.finalIndexLevel.split('.')[0].replace(/,/g, '')).toLocaleString()
        + (this.finalIndexLevel.split('.')[1] !== undefined ? '.' + this.finalIndexLevel.split('.')[1] : '');
    }
  }

  validateNumber(event: any): void {
    // tslint:disable-next-line:radix
    if ((parseInt(event.key) >= 0 && parseInt(event.key) <= 9) || event.key === 'Backspace' || event.key === 'Tab' || event.key === '.'){
      this.formatNotional(event);
    }else if (event.key === 'Enter'){
      this.formatNotional(event);
    }else{
      event.preventDefault();
    }
  }

  formatNotional(event: any): void {
    this.notional = isNaN(parseFloat(this.notional)) ? '' : this.notional;
    this.initialIndexLevel = isNaN(parseFloat(this.initialIndexLevel)) ? '' : this.initialIndexLevel;
    this.finalIndexLevel = isNaN(parseFloat(this.finalIndexLevel)) ? '' : this.finalIndexLevel;
    if ((event.type === 'click' || event.code === 'Enter') && this.validTradeDate) {

      switch (this.currentView) {
        case 'Upfront & Coupon calculator':
          this.enableCalculate = !isNaN(parseFloat(this.notional));
          break;
        case 'Unwind calculator':
          this.enableCalculate = !isNaN(parseFloat(this.notional)) && !isNaN(parseFloat(this.initialIndexLevel))
            && !isNaN(parseFloat(this.finalIndexLevel));
          break;
      }
      if (this.enableCalculate){
        this.updateIMMDates();
        switch (this.calcType) {
          case 'USD': this.getSOFRAIValues();
                      break;
          case 'EUR': this.getEuriborValues();
                      break;
        }
      }
    }

  }

  getSOFRAIValues(): void{
    this.previousSofrai = '';
    this.sofrai = '';
    this.nextSofrai = '';
    this.loader.show();
    this.apiService.getSOFRAIValueFor(this.formatDateAsISO(new Date(this.priorIMMDateDiff)),
      this.formatDateAsISO(new Date(this.priorIMMDateDiff))).subscribe((resp: any) => {
      this.previousSofrai = resp.refRates.length > 0 ? resp.refRates[0].index : '';
    });
    this.apiService.getSOFRAIValueFor(this.formatDateAsISO(new Date(this.previousDate)),
      this.formatDateAsISO(new Date(this.previousDate))).subscribe((resp: any) => {
      this.sofrai = resp.refRates.length > 0 ? resp.refRates[0].index : '';
    });
    this.apiService.getSOFRAIValueFor(this.formatDateAsISO(new Date(this.nextIMMDateDiff)),
      this.formatDateAsISO(new Date(this.nextIMMDateDiff))).subscribe((resp: any) => {
      this.nextSofrai = resp.refRates.length > 0 ? resp.refRates[0].index : 'Not known as of Trade Date (T)';
      this.loader.hide();
    });
  }

  getEuriborValues(): void{
    this.shareService.euriborValue.forEach((value: any) => {
      if (this.formatDate(new Date(Object.keys(value)[0])) === this.priorIMMDateDiff){
        // @ts-ignore
        this.prevEuribor = (Object.values(value)[0] / 100).toFixed(Object.values(value)[0].length - 1);
      }
    });
  }

  calculateUSDOutput(): void {
    this.enableOutput = true;
    this.showOutput = true;

    const notional = this.notional.replace(/,/g, '');
    const initialIndexLevel = this.initialIndexLevel.replace(/,/g, '');
    const finalIndexLevel = this.finalIndexLevel.replace(/,/g, '');
    this.effectiveDate = this.formatDate(this.utilService.addDaysTo(new Date(new Date(this.tradeDate).toISOString().slice(0, -1)), 1));
    this.firstCouponDate = this.formatDate(new Date(this.nextIMMDate));
    const performanceLeg = (((parseFloat(finalIndexLevel) / parseFloat(initialIndexLevel)) - 1) * parseFloat(notional));
    this.performanceLeg = performanceLeg.toLocaleString();

    const accruedFloatingRate = ((((parseFloat(this.sofrai) / parseFloat(this.previousSofrai)) - 1) * 360) /
      this.utilService.differenceInDate(new Date(this.previousDate), new Date(this.priorIMMDateDiff))).toFixed(9);
    this.accruedFloatingRate = parseFloat(accruedFloatingRate).toFixed(9);

    if (new Date(this.tradeDate).getTime() !== new Date(this.maturityDate).getTime()) {
      this.accruedAmount = (parseFloat(notional) *
        (this.utilService.differenceInDate(new Date(this.effectiveDate), new Date(this.priorIMMDate)) / 360) *
        parseFloat(accruedFloatingRate) * (this.currentView === 'Unwind calculator' ? -1 : 1)).toFixed(9);
    }

    let couponFloatingRate = '';
    if (this.nextSofrai === 'Not known as of Trade Date (T)') {
      this.couponFloatingRate = 'Not known as of Trade Date (T)';
      this.firstCouponAmount = 'Not known as of Trade Date (T)';
    } else {
      couponFloatingRate = ((((parseFloat(this.nextSofrai) / parseFloat(this.previousSofrai)) - 1) * 360) /
        this.utilService.differenceInDate(new Date(this.nextIMMDateDiff), new Date(this.priorIMMDateDiff))).toFixed(9);
      this.couponFloatingRate = parseFloat(couponFloatingRate).toFixed(9);

      this.firstCouponAmount = (-1 * parseFloat(notional) * parseFloat(couponFloatingRate) *
        (new Date(this.maturityDate).getTime() === new Date(this.nextIMMDate).getTime() ?
          (this.utilService.differenceInDate(new Date(this.firstCouponDate), new Date(this.priorIMMDate)) + 1) / 360 :
          (this.utilService.differenceInDate(new Date(this.firstCouponDate), new Date(this.priorIMMDate))) / 360)).toFixed(4);
    }
    this.accruedAmount = ((this.currentView === 'Unwind calculator' ? -1 : 1) * parseFloat(notional) *
      (this.utilService.differenceInDate(new Date(this.effectiveDate), new Date(this.priorIMMDate)) / 360) *
      (new Date(this.formatDate(new Date(this.tradeDate))).getTime() === new Date(this.maturityDate).getTime()
        ? parseFloat(couponFloatingRate)
        : parseFloat(accruedFloatingRate))).toFixed(4);


    this.tradeValue = new Date(this.tradeDateToDisplay).getTime() === new Date(this.maturityDate).getTime()
      ? performanceLeg.toLocaleString()
      : (performanceLeg + parseFloat(this.accruedAmount)).toLocaleString('en-US', {minimumFractionDigits: 4});


    this.lastCouponDate = this.maturityDate;

    this.enableCalculate = false;
  }

  calculateEUROutput(): void {
    this.enableOutput = true;
    this.showOutput = true;
    const notional = this.notional.replace(/,/g, '');
    const initialIndexLevel = this.initialIndexLevel.replace(/,/g, '');
    const finalIndexLevel = this.finalIndexLevel.replace(/,/g, '');
    this.effectiveDate = this.formatDate(this.utilService.addDaysTo(new Date(new Date(this.tradeDate).toISOString().slice(0, -1)), 1));
    this.accruedFloatingRate = this.prevEuribor;

    this.accruedAmount = ((parseFloat(notional) *
      (this.utilService.differenceInDate(new Date(this.effectiveDate), new Date(this.priorIMMDate)) / 360) *
      parseFloat(this.accruedFloatingRate)) * (this.currentView === 'Unwind calculator' ? -1 : 1))
      .toLocaleString('en-US', {minimumFractionDigits: 4});

    const performanceLeg = (parseFloat(notional) *
      ((parseFloat(finalIndexLevel) / parseFloat(initialIndexLevel)) - 1));
    this.performanceLeg = performanceLeg.toLocaleString();

    this.tradeValue = new Date(this.formatDate(new Date(this.tradeDate))).getTime() === new Date(this.maturityDate).getTime()
      ? performanceLeg.toLocaleString()
      : (performanceLeg + parseFloat(this.accruedAmount)).toLocaleString();

    this.firstCouponDate = this.nextIMMDate;
    this.couponFloatingRate = this.prevEuribor;

    this.firstCouponAmount = ((-1) * parseFloat(notional) * parseFloat(this.couponFloatingRate) *
      (new Date(this.maturityDate).getTime() === new Date(this.nextIMMDate).getTime() ?
        ((this.utilService.differenceInDate(new Date(this.firstCouponDate), new Date(this.priorIMMDate)) + 1) / 360) :
        ((this.utilService.differenceInDate(new Date(this.firstCouponDate), new Date(this.priorIMMDate))) / 360)))
      .toLocaleString('en-US', {minimumFractionDigits: 4});

    this.lastCouponDate = this.maturityDate;

    this.enableCalculate = false;
  }

  openTab(event: any): void {
    switch (event) {
      case 'screener':
        this.route.navigateByUrl('iBoxx/TRS/Screener');
        break;
      case 'documentation':
        this.route.navigateByUrl('TRS/docs/page?docFor=iBoxx');
        break;
      default:
        this.openDrillDownPage(event);
        break;
    }
  }

  openDrillDownPage(identifier: string): void {
    const index = this.shareService.headlineIndices.find((data: any) => {
      if (data.indexName === identifier.split('?')[0] && data.inflationAdjustment === identifier.split('?')[1]) {
        return data;
      }
    });
    this.route.navigateByUrl('iBoxx/details/index?id=' + index.id);
  }

  changeHeader(event: any): void {
    this.calcType = event.value;
    this.getHolidays();
    this.tradeDateChanged();
    // this.currentView = 'Disclaimer';
  }

  isHoliday(date: Date): boolean {
    const eventDates = this.holidays.map((holiday: any) => new Date(this.utilService.formatDate(holiday.eventDate)));
    // @ts-ignore
    return eventDates.find((eventDate: Date) => eventDate.getTime() === date.getTime());
  }

  getHolidayName(date: Date): string {
    // @ts-ignore
    return this.holidays.find((holiday: any) =>
      new Date(this.utilService.formatDate(holiday.eventDate)).getTime() === date.getTime()).eventName;
  }

  isWeekend(date: Date): boolean {
    return date.getDay() === 6 || date.getDay() === 0;
  }

  getValidBusinessDate(date: Date, order: string): Date {
    while (this.isHoliday(date) || this.isWeekend(date)) {
      date = this.utilService.addDaysTo(date, order === 'forward' ? 1 : -1);
    }
    return date;
  }
}
